import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Icon,
  Box,
  Drawer,
  Button,
} from "@material-ui/core";
import Profile from "./Profile";
import MobileRecursiveMenu from "./MobileRecursiveMenu";

const MobileHeader = ({
  logo,
  client,
  user,
  shoppingCarts,
  classes,
  handleDrawerToggle,
  mobileOpen,
  menu,
  parseTitle,
  statusAssociated,
}) => (
  <AppBar className={classes.header}>
    <Toolbar className={classes.mainMenuMobile}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        className={classes.menuIcon}
        onClick={handleDrawerToggle}
      >
        <Icon>menu</Icon>
      </IconButton>
      {logo && (
        <a href="/" className={classes.logo}>
          <img alt={`Logo da ${client}`} src={logo} />
        </a>
      )}
      <Box className={classes.authenticateContainer}>
        {user?.data ? (
          <Profile
            user={user}
            classes={classes}
            shoppingCarts={shoppingCarts}
            statusAssociated={statusAssociated}
          />
        ) : (
          <Button
            href="/login"
            variant="contained"
            className={classes.loginButton}
          >
            Login
          </Button>
        )}
      </Box>
    </Toolbar>
    <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
      <MobileRecursiveMenu
        items={menu}
        classes={classes}
        parseTitle={parseTitle}
      />
    </Drawer>
  </AppBar>
);

export default MobileHeader;
